var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CONFIG } from "../../config/app.config";
import { EProduct } from "../../config/app.config.types";
import api from "../../utils/api/api.utils";
// `code` is a string, not a number: the pincode field is a text input and the SMS
// token can start with a zero, which parsing to a number would silently strip.
export var verifyPhone = function (userId, code) {
    return api.post("/auth/confirm-phone", {
        data: { uid: String(userId), token: code },
        isV2: true,
    });
};
export var adminVerifyEmail = function (userId) {
    return api.post("/oauth/admin-confirm-email?uid=".concat(userId));
};
export var adminVerifyPhone = function (userId) {
    return api.post("/oauth/admin-confirm-phone?uid=".concat(userId));
};
export var signUp = function (data) {
    return api.post("/users", {
        data: data,
        authenticated: false,
        isV2: true,
    });
};
export var resendVerificationEmail = function (email) {
    return api.post("/auth/confirm-email/resend", {
        data: { email: email },
        isV2: true,
    });
};
export var resendVerificationSms = function (phone) {
    return api.post("/auth/confirm-phone/resend", {
        data: { phone: phone },
        isV2: true,
    });
};
// Called from the phone-number login screen, before the caller has a session -
// mirrors legacy `GET /users/exists/phone/:phone`.
export var existsPhone = function (phone) {
    return api.post("/users/phone/exists", {
        data: { phone: phone },
        isV2: true,
        authenticated: false,
    });
};
export var getUser = function () { return __awaiter(void 0, void 0, void 0, function () {
    var isInsuranceProduct, response_1, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isInsuranceProduct = CONFIG.PRODUCT === EProduct.Insurance ||
                    CONFIG.PRODUCT === EProduct.InsuranceBackoffice;
                if (!isInsuranceProduct) return [3 /*break*/, 2];
                return [4 /*yield*/, api.get("/users/me", { isV2: true })];
            case 1:
                response_1 = _a.sent();
                return [2 /*return*/, response_1.data];
            case 2: return [4 /*yield*/, api.get("/users/me", {
                    isV2: true,
                })];
            case 3:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
// Served by V2 and unwrapped here, so callers get the TAC itself instead of the
// { data: T } envelope. Neither endpoint depends on the caller, and `getTac` is
// fetched before sign-in, so both are public.
var fetchTac = function (path) { return __awaiter(void 0, void 0, void 0, function () {
    var isInsuranceProduct, response_2, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isInsuranceProduct = CONFIG.PRODUCT === EProduct.Insurance ||
                    CONFIG.PRODUCT === EProduct.InsuranceBackoffice;
                if (!isInsuranceProduct) return [3 /*break*/, 2];
                return [4 /*yield*/, api.get(path, { isV2: true })];
            case 1:
                response_2 = _a.sent();
                return [2 /*return*/, response_2.data];
            case 2: return [4 /*yield*/, api.get(path, {
                    isV2: true,
                })];
            case 3:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var getTac = function (locale, platform, brokerId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, fetchTac("/brokers/".concat(brokerId || CONFIG.RENTIO_BROKER_ID, "/tac/").concat(platform, "/").concat(locale))];
    });
}); };
export var getTacById = function (tacId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, fetchTac("/tac/".concat(tacId))];
}); }); };
// The v2 UpdateUserDto only accepts these fields and rejects unknown props (422).
// Verified `email`/`phone` are not directly settable —
// changes go through `unverifiedEmail`/`unverifiedPhone`.
var V2_UPDATE_USER_FIELDS = [
    "firstname",
    "lastname",
    "locale",
    "unverifiedEmail",
    "unverifiedPhone",
];
export var updateUser = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = V2_UPDATE_USER_FIELDS.reduce(function (acc, key) {
                    if (data[key] !== undefined) {
                        acc[key] = data[key];
                    }
                    return acc;
                }, {});
                return [4 /*yield*/, api.patch("/users/me", {
                        data: payload,
                        isV2: true,
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var updateUserById = function (id, data) {
    return api.patch("/users/".concat(id), { data: data, isV2: true });
};
export var acceptTac = function (userId, tacId) {
    return api.post("/users/".concat(userId, "/tac/").concat(tacId, "/accept"), { isV2: true });
};
export var removeProfile = function () {
    return api.delete("/users/me/application/profile");
};
